import { Theme } from "@mui/material/styles"
import { paperClasses } from "@tm/components"
import { LatestActivitiesWidgetTheme } from "core/themes/src/definitions/components.types"

export const createLatestActivitiesWidgetTheme = (_: Theme): LatestActivitiesWidgetTheme => ({
    styleOverrides: {
        root: {
            height: "32.8em",
            [`.${paperClasses.root}`]: {
                padding: "1em",
            },
        },
    },
})
